<p-toast />
<div *ngIf="showBackdrop" class="backdrop" id="backdrop">
  <div class="backdrop-content">
    <img width="200" src="assets/images/logo/confe-light-web.svg" alt="Confe.iologo" />
    <h3>Login window is open. Don't close this window until you're finished with the login.</h3>
    <h3>
      Can't see the login window? We'll help you re-launch it to complete your connection.
      <span (click)="showConnectionWindow()">click here to reopen it</span>.
    </h3>
  </div>
</div>

<div class="boardWrap">
  <div class="titleBlock">
    <h4 class="text-center">{{ workspaceDetails?.name }}</h4>
    <p>
      You can now connect your business social accounts to this workspace. Click below to get
      started.
    </p>
  </div>
  <div class="createWorkspace">
    <!-- <div class="desc">
      <div class="memberView">
        <div>
          <h5 class="text-uppercase">Members</h5>
        </div>
        <div *ngIf="workspaceDetails?.members.length" class="memeber">
          <ul>
            <li tooltipPosition="top" *ngFor="let member of workspaceDetails.members">
              <div [pTooltip]="member.name || member.email.split('@')[0]" class="img">
                {{ member.name ? member.name.charAt(0) : member.email.charAt(0).toUpperCase() }}
              </div>
              &lt;!&ndash;   <a [pTooltip]="member.name || member.email.split('@')[0]" tooltipPosition="top">
                <div class="img megadrive-screen-bg">
                  {{ member.name.charAt(0) || member.email.charAt(0) }}
                </div>
              </a>&ndash;&gt;
            </li>
          </ul>
        </div>
      </div>
    </div>-->

    <div class="connect">
      @if (workspacePermission) {
        <div class="connectHead">
          <h4>Connect Account in workspace</h4>
          <span><!--Upto {{ workspacePermission.NumberOfSocialAccounts }}--></span>
        </div>
      }
      <ul class="list-unstyled">
        @if (environment.channels.facebook) {
          <li
            [class.disabled]="
              isTotalConnectionMaxLimitReached() ||
              isConnectionByBrandMaxLimitReached(providers.FACEBOOK)
            "
          >
            <a
              (click)="
                isTotalConnectionMaxLimitReached()
                  ? $event.preventDefault()
                  : clickConnect($event, { provider: 'facebook_page', type: 'page' })
              "
            >
              <div class="icon">
                <img src="/assets/images/logo/facebook.svg" alt="" />
              </div>
              <h6>Facebook</h6>
            </a>
            <ng-container *ngIf="isConnectionByBrandMaxLimitReached(providers.FACEBOOK)">
              <div class="checked-icon">
                <i class="pi pi-check-circle" style="font-size: 1rem; font-weight: bold"></i>
              </div>
            </ng-container>
            <div
              *ngIf="
                isTotalConnectionMaxLimitReached() ||
                isConnectionByBrandMaxLimitReached(providers.FACEBOOK)
              "
              class="overlay"
            ></div>
          </li>
        }
        @if (environment.channels.instagram) {
          <li
            [class.disabled]="
              isTotalConnectionMaxLimitReached() ||
              isConnectionByBrandMaxLimitReached(providers.INSTAGRAM)
            "
          >
            <a (click)="clickConnect($event, { provider: providers.INSTAGRAM, type: 'page' })">
              <div class="icon">
                <img src="/assets/images/logo/instagram.svg" alt="" />
              </div>
              <h6>Instagram</h6>
            </a>
            <ng-container *ngIf="isConnectionByBrandMaxLimitReached(providers.INSTAGRAM)">
              <div class="checked-icon">
                <i class="pi pi-check-circle" style="font-size: 1rem; font-weight: bold"></i>
              </div>
            </ng-container>
            <div
              *ngIf="
                isTotalConnectionMaxLimitReached() ||
                isConnectionByBrandMaxLimitReached(providers.INSTAGRAM)
              "
              class="overlay"
            ></div>
          </li>
        }
        @if (environment.channels.linkedin) {
          <li
            [class.disabled]="
              isTotalConnectionMaxLimitReached() ||
              isConnectionByBrandMaxLimitReached(providers.LINKEDIN)
            "
          >
            <a (click)="openLinkedinDialog()">
              <div class="icon">
                <img src="/assets/images/logo/linkedin.svg" alt="LinkedIn" />
              </div>
              <h6>LinkedIn</h6>
            </a>
            <ng-container
              *ngIf="
                isConnectionByBrandMaxLimitReached(providers.LINKEDIN) ||
                isConnectionByBrandMaxLimitReached(providers.LINKEDIN_PAGE)
              "
            >
              <div class="checked-icon">
                <i class="pi pi-check-circle" style="font-size: 1rem; font-weight: bold"></i>
              </div>
            </ng-container>
            <div
              *ngIf="
                isTotalConnectionMaxLimitReached() ||
                isConnectionByBrandMaxLimitReached(providers.LINKEDIN) ||
                isTotalConnectionMaxLimitReached() ||
                isConnectionByBrandMaxLimitReached(providers.LINKEDIN_PAGE)
              "
              class="overlay"
            ></div>
          </li>
        }
        @if (environment.channels.pinterest) {
          <li
            [class.disabled]="
              isTotalConnectionMaxLimitReached() ||
              isConnectionByBrandMaxLimitReached(providers.PINTEREST)
            "
            (click)="clickConnect($event, { provider: 'pinterest', type: 'personal' })"
          >
            <a>
              <div class="icon">
                <img src="/assets/images/logo/pinterest.svg" alt="" />
              </div>
              <h6>Pinterest</h6>
            </a>
            <ng-container *ngIf="isConnectionByBrandMaxLimitReached(providers.PINTEREST)">
              <div class="checked-icon">
                <i class="pi pi-check-circle" style="font-size: 1rem; font-weight: bold"></i>
              </div>
            </ng-container>
            <div
              *ngIf="
                isTotalConnectionMaxLimitReached() ||
                isConnectionByBrandMaxLimitReached(providers.PINTEREST)
              "
              class="overlay"
            ></div>
          </li>
        }
        @if (environment.channels.tiktok) {
          <li
            [class.disabled]="
              isTotalConnectionMaxLimitReached() ||
              isConnectionByBrandMaxLimitReached(providers.TIKTOK)
            "
          >
            <a (click)="clickConnect($event, { provider: 'tiktok', type: 'personal' })">
              <div class="icon">
                <img src="/assets/images/logo/tiktok.svg" alt="" />
              </div>
              <h6>Tiktok</h6>
            </a>
            <ng-container *ngIf="isConnectionByBrandMaxLimitReached(providers.TIKTOK)">
              <div class="checked-icon">
                <i class="pi pi-check-circle" style="font-size: 1rem; font-weight: bold"></i>
              </div>
            </ng-container>
            <div
              *ngIf="
                isTotalConnectionMaxLimitReached() ||
                isConnectionByBrandMaxLimitReached(providers.TIKTOK)
              "
              class="overlay"
            ></div>
          </li>
        }
        @if (environment.channels.youtube) {
          <li
            [class.disabled]="
              isTotalConnectionMaxLimitReached() ||
              isConnectionByBrandMaxLimitReached(providers.YOUTUBE)
            "
          >
            <a (click)="clickConnect($event, { provider: 'youtube', type: 'page' })">
              <div class="icon">
                <img src="/assets/images/logo/youtube.svg" alt="" />
              </div>
              <h6>Youtube</h6>
            </a>
            <ng-container *ngIf="isConnectionByBrandMaxLimitReached(providers.YOUTUBE)">
              <div class="checked-icon">
                <i class="pi pi-check-circle" style="font-size: 1rem; font-weight: bold"></i>
              </div>
            </ng-container>
            <div
              *ngIf="
                isTotalConnectionMaxLimitReached() ||
                isConnectionByBrandMaxLimitReached(providers.YOUTUBE)
              "
              class="overlay"
            ></div>
          </li>
        }
        @if (environment.channels.twitter) {
          <li
            [class.disabled]="
              isTotalConnectionMaxLimitReached() ||
              isConnectionByBrandMaxLimitReached(providers.TWITTER)
            "
          >
            <a (click)="clickConnect($event, { provider: 'twitter', type: 'personal' })">
              <div class="icon">
                <img src="/assets/images/logo/twitter.svg" alt="" />
              </div>
              <h6>Twitter</h6>
              <ng-container *ngIf="isConnectionByBrandMaxLimitReached(providers.TWITTER)">
                <div class="checked-icon">
                  <i class="pi pi-check-circle" style="font-size: 1rem; font-weight: bold"></i>
                </div>
              </ng-container>
              <div
                *ngIf="
                  isTotalConnectionMaxLimitReached() ||
                  isConnectionByBrandMaxLimitReached(providers.TWITTER)
                "
                class="overlay"
              ></div>
            </a>
          </li>
        }
        @if (environment.channels.threads) {
          <li
            [class.disabled]="
              isTotalConnectionMaxLimitReached() ||
              isConnectionByBrandMaxLimitReached(providers.THREADS)
            "
          >
            <a (click)="clickConnect($event, { provider: 'threads', type: 'personal' })">
              <div class="icon">
                <img src="/assets/images/logo/threads.svg" alt="" />
              </div>
              <h6>Threads</h6>
            </a>
            <ng-container *ngIf="isConnectionByBrandMaxLimitReached(providers.THREADS)">
              <div class="checked-icon">
                <i class="pi pi-check-circle" style="font-size: 1rem; font-weight: bold"></i>
              </div>
            </ng-container>
            <div
              *ngIf="
                isTotalConnectionMaxLimitReached() ||
                isConnectionByBrandMaxLimitReached(providers.THREADS)
              "
              class="overlay"
            ></div>
          </li>
        }
      </ul>
    </div>

    <div *ngIf="connectedAccounts.length" class="connectedAccounts">
      <div class="titleHead">
        <h4>Connections</h4>
        <span>
          <!--{{ connectedAccounts.length || 0 }}/{{
            workspacePermission.NumberOfSocialAccounts
          }}
          Connected-->
        </span>
      </div>
      <div class="acountsList">
        <!-- <p-carousel [numVisible]="1.2" [numScroll]="1"> -->
        <!-- <ng-template item> -->
        <p-carousel
          [value]="connectedAccounts"
          [numVisible]="1"
          [numScroll]="1"
          [showIndicators]="false"
        >
          <ng-template let-account pTemplate="item" let-i="index">
            <div class="listWrap">
              <div class="connectImg">
                <!-- <div class="img">
                  <img src="{{ environment.s3ImageBasePath + account.media.path }}" alt="" />
                </div>-->
                <div class="img">
                  <img
                    src="{{
                      account.media
                        ? environment.s3ImageBasePath + account.media.path
                        : account.image
                          ? account.image
                          : ''
                    }}"
                    alt="Profile Picture"
                    *ngIf="account.media?.path || account.image"
                  />
                  <ng-template #defaultAvatar>
                    <p-avatar
                      icon="pi pi-user"
                      styleClass="mr-2"
                      [style]="{ 'background-color': '#9c27b0', color: '#ffffff' }"
                      shape="circle"
                      [label]="account.name.charAt(0).toUpperCase()"
                    ></p-avatar>
                  </ng-template>
                  <div *ngIf="!account.media?.path && !account.image">
                    <ng-container *ngTemplateOutlet="defaultAvatar"></ng-container>
                  </div>
                </div>

                <div class="socialTag">
                  <img
                    [src]="'assets/images/logo/' + (account.provider | providerIcon) + '-small.svg'"
                    alt=""
                  />
                </div>
              </div>
              <div class="details">
                <h5>{{ account.name }}</h5>
                <strong>{{ account.provider == PROVIDERS.LINKEDIN_PAGE ? '(Page)' : '' }}</strong>
              </div>
              <div class="btnBlock ml-auto">
                <div class="delete ml-auto">
                  <p-button
                    (click)="deleteAccount($event, account.uuid)"
                    pTooltip="Disconnect account"
                    tooltipPosition="top"
                    icon="pi pi-times"
                    [rounded]="true"
                    severity="danger"
                  ></p-button>
                  <p-confirmPopup />
                </div>
              </div>
            </div>
          </ng-template>
        </p-carousel>
      </div>
    </div>
  </div>

  <p-button
    [disabled]="preventAbuse"
    [loading]="preventAbuse"
    styleClass="blueBtn"
    label="{{ connectedAccounts.length ? 'Next' : 'Skip this Step' }}"
    icon="pi pi-arrow-right"
    iconPos="right"
    (click)="setOnboardingCompleted()"
  ></p-button>
</div>

<!--<app-social-popup-facebook (social-media-connection)="connectToProvider($event)" *ngIf="connect_facebook" />-->
<!--<app-social-popup-instagram (social-media-connection)="connectToProvider($event)" *ngIf="connect_instagram" />-->

<!--<app-connection-list-popup
  *ngIf="requestId"
  [provider]="provider"
  [connectionList]="connectionList"
  [requestId]="requestId"
/>-->
